import React from "react";

//UI Material
import { Button, Stack, TableCell, TableRow, Typography } from "@mui/material";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

//Dictionaries
import { productTypes } from "../../Dictionaries/products";

export default function ProducRow({ product }) {
  // ==========> Component <==========
  return (
    <TableRow>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{product.productName}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{product.details}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">
          {productTypes.find((type) => type.value === product.type)?.name ||
            product.type}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{`₡${Number(
          product.priceInCRC
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{`$${Number(
          product.priceInUSD
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`}</Typography>
      </TableCell>
      <TableCell align="center">
        <Stack direction="row" spacing={1} justifyContent="center">
          <Button
            size="small"
            variant="contained"
            color="secondary"
            sx={{ color: "white" }}
            endIcon={<ArrowForwardIos />}
            onClick={() => {
              window.location.href = `/product?productId=${product.productId}`;
            }}
          >
            Ver producto
          </Button>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
